import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import StyledItem from './Item.style';

var Item = function Item(_ref) {
  var children = _ref.children,
      target = _ref.target,
      restProps = _objectWithoutProperties(_ref, ["children", "target"]);

  return React.createElement(StyledItem, Object.assign({
    target: "_".concat(target)
  }, restProps), children);
};

export default Item;